/* eslint-disable max-len */
import { CheckCircleFilled } from '@ant-design/icons';
import React from 'react';
import { Button } from '..';
import { toRupiah, pluralWriter } from '../../utils/commonUtils';
import { PricingItemWrapper } from './style';
import { sortingInformationList } from './licenseFeaturesUtils';
import { renewalType, licenseID, emailContact } from '../../configs/license';

const PricingItem = (props) => {
  const { dataSource, selectedMenu, onChooseLicense, licenseConfig } = props;

  const isEnterprise = licenseConfig?.id === licenseID.enterprise.id;

  const licensePeriod = renewalType.find((item) => {
    return item.value === selectedMenu;
  });

  const selectedPrice = dataSource?.[licensePeriod?.attribute];
  const calculateDiscount = () => {
    return Math.floor(
      100 - (selectedPrice * 100) / (selectedPrice * licensePeriod.month)
    );
  };

  const informationItem = (key, text) => {
    const value = dataSource[key];
    if (!value) return null;
    if (key === 'max_team_member') {
      text = `Max ${value} client ${pluralWriter({
        word: 'user',
        value,
      })}`;
    }
    if (key === 'max_socmed_account') {
      text = `Max ${value} social ${pluralWriter({
        word: 'account',
        value,
      })}`;
    }
    return (
      <div key={key} className="container_pricing_item_information_list_item">
        <CheckCircleFilled />
        <span className="font-subtitle2">{text}</span>
      </div>
    );
  };
  const mailto = (e) => {
    window.location = `mailto:${emailContact}`;
    onChooseLicense(dataSource, selectedMenu);
    e.preventDefault();
  };

  const description = `Each ${dataSource?.name} license has a maximum of ${dataSource?.max_team_member} member and starts with ${dataSource?.max_socmed_account} social accounts.`;

  return (
    <PricingItemWrapper
      bgImage={licenseConfig?.image}
      primaryColor={licenseConfig?.primaryColor}
      shadowColor={licenseConfig?.shadowColor}
      secondaryColor={licenseConfig?.secondaryColor}
    >
      <div className="container_pricing_item_box">
        <div className="component_pricing_item_header">
          <div>
            <div className="font-header3_medium component_pricing_item_header_title">
              {dataSource?.name}
            </div>
            <div className="font-subtitle1_medium component_pricing_item_header_subtitle">
              {selectedMenu !== 1 &&
                !isEnterprise &&
                `Save up to ${calculateDiscount()}%`}
            </div>
          </div>
          <div className="font-subtitle2 component_pricing_item_header_desc">
            {description}
          </div>
        </div>

        <div
          className={`component_pricing_item_body ${
            isEnterprise ? 'component_pricing_enterprise' : ''
          }`}
        >
          {!isEnterprise ? (
            <div>
              <div className="font-header3_medium component_pricing_item_body_currency">
                IDR
              </div>
              <div className="component_pricing_item_body_price">
                {toRupiah(dataSource?.[licensePeriod.attribute]).slice(2)}
              </div>
              <div className="font-subtitle1_medium component_pricing_item_body_time">
                {`/ ${licensePeriod.period}`}
              </div>
            </div>
          ) : (
            // eslint-disable-next-line react/no-unescaped-entities
            <div className="font-header1_bold">Let's Talk</div>
          )}
        </div>

        <div className="component_pricing_item_footer">
          <Button
            block
            size="large"
            onClick={(e) => {
              if (isEnterprise) return mailto(e);
              return onChooseLicense(dataSource, selectedMenu);
            }}
          >
            {isEnterprise && 'Contact Us'}
            {!isEnterprise && 'Choose License'}
          </Button>
        </div>
      </div>
      <div className="container_pricing_item_information">
        <div className="container_pricing_item_information_list">
          {sortingInformationList.map((item) => {
            return informationItem(item?.key, item?.text);
          })}
        </div>
      </div>
    </PricingItemWrapper>
  );
};

export default PricingItem;
